import React from "react";
import SpinningLoader from "../components/SpinningLoader";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * OnboardingPrivate - protects onboarding routes
 * Ensures user is authenticated but allows incomplete profiles
 * Redirects completed users to dashboard
 */
const OnboardingPrivate = ({ children }) => {
  const { userProfile, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  // Show spinner while loading
  if (loading) {
    return <SpinningLoader />;
  }

  // Must be authenticated to access onboarding
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Wait for user profile to load
  if (!userProfile) {
    return <SpinningLoader />;
  }

  // If user has completed verification, redirect to dashboard
  if (
    userProfile.veriffDetails?.status === "approved" &&
    userProfile.profile_completed
  ) {
    return <Navigate to="/" replace />;
  }

  // If email not verified, only allow verify-email page
  if (!userProfile.emailVerified) {
    if (location.pathname !== "/onboarding/verify-email") {
      return <Navigate to="/onboarding/verify-email" replace />;
    }
    return children;
  }

  // If profile not completed, redirect to complete profile
  if (!userProfile.profile_completed) {
    const allowedRoutes = ["/complete-profile", "/onboarding/welcome"];
    if (!allowedRoutes.includes(location.pathname)) {
      const storedEmails =
        JSON.parse(localStorage.getItem("verifiedEmails")) || [];
      const emailVerifiedFromStorage = storedEmails.includes(userProfile.email);
      if (emailVerifiedFromStorage) {
        return <Navigate to="/complete-profile" replace />;
      } else {
        return <Navigate to="/onboarding/welcome" replace />;
      }
    }
    return children;
  }

  // Allow access to onboarding pages
  return children;
};

export default OnboardingPrivate;
